import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { string } from 'prop-types';
import theme from 'oems/theme';
import * as Styled from '../pricing.styles';
import * as IndicatorStyled from './availableIndicator.styles';
import { Stack } from '@mui/material';

export const AvailableIndicator = (present) => {
  let text = false;
  if (typeof present.present === 'string') {
    text = true;
  }
  return (
    <>
      {text && (
        <IndicatorStyled.Stack>
          <Styled.h4>{present.present}</Styled.h4>
        </IndicatorStyled.Stack>
      )}
      {!text && present.present && <CheckCircleOutlineIcon sx={{ color: (theme) => theme.palette.pricing.present }} />}
      {!text && !present.present && <CancelOutlinedIcon sx={{ color: (theme) => theme.palette.text.main }} />}
    </>
  );
};
